// Minimal hash router. Routes:
//   #/                  -> home (game catalog)
//   #/g/:id             -> level select for a game
//   #/g/:id/:level      -> play a level
//   #/shop              -> cosmetics shop
//   #/settings          -> settings

export interface Route {
  name: "home" | "game" | "play" | "settings" | "shop";
  gameId?: string;
  level?: number;
}

export function parseRoute(): Route {
  const hash = location.hash.replace(/^#\/?/, "");
  const parts = hash.split("/").filter(Boolean);
  if (parts.length === 0) return { name: "home" };
  if (parts[0] === "settings") return { name: "settings" };
  if (parts[0] === "shop") return { name: "shop" };
  if (parts[0] === "g" && parts[1]) {
    if (parts[2]) {
      // Sanitize: only positive integers; anything else (floats, NaN, negatives) -> 1.
      const n = Math.floor(Number(parts[2]));
      return { name: "play", gameId: parts[1], level: Number.isFinite(n) && n >= 1 ? n : 1 };
    }
    return { name: "game", gameId: parts[1] };
  }
  return { name: "home" };
}

export function navigate(path: string): void {
  if (location.hash === `#${path}`) {
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    location.hash = path;
  }
}

export function onRoute(cb: (route: Route) => void): void {
  window.addEventListener("hashchange", () => cb(parseRoute()));
  cb(parseRoute());
}
